import { Box, styled } from '@mui/material';

export const StyledSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const StyledDownloadRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

export const StyledExecuteRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

export const StyledFindingsBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  height: 300
}));
